import { Tab, Tabs } from "@mui/material";
import { AavoMosaicPanel } from "./types";

export interface AavoMosaicWindowToolbarProps {
	items: AavoMosaicPanel[];
	activeItemIndex: number;
	setActiveItemIndex: (index: number) => void;
}

export const AavoMosaicWindowToolbar = ({
	items,
	activeItemIndex,
	setActiveItemIndex,
}: AavoMosaicWindowToolbarProps) => {
	return (
		<Tabs
			value={activeItemIndex}
			onChange={(_, newValue) => setActiveItemIndex(newValue)}
			sx={{
				minHeight: 0,
				alignSelf: "stretch",
				"& .MuiTabs-scroller": {
					display: "flex",
				},
			}}
		>
			{items.map((item, index) => {
				return (
					<Tab
						label={item.title}
						key={index}
						sx={{
							alignSelf: "center",
							minHeight: 0,
							padding: 0,
							paddingLeft: 1.5,
							outline: "none !important",
						}}
					/>
				);
			})}
		</Tabs>
	);
};
